var VoucherItem = (function (Model) {
    return Model.extend({
        idAttribute: 'ID',

        apply: function () {
            if (this.get('IsApplied') !== true) {
                window.app && app.event && app.event.applyVoucher();
                return this._api.applyVoucher(this.id).done(this._updateCheckout);
            }
            else {
                return this._api.removeVoucher(this.id).done(this._updateCheckout);
            }
            return new $.Deferred().reject().promise();
        }
    });
})(CheckoutApiModel);
